import React, { useState, useEffect, useRef, useContext } from 'react'
import { FormattedMessage, FormattedDate } from 'react-intl'
import Icon from 'components/Icon'
import messages from './messages'

const Th = ({ children }) => (
  <th scope="col" className="whitespace-nowrap sticky top-0 bg-gray-50 px-1 md:px-2 xl:px-4 py-2 xl:py-3 text-xs font-medium text-gray-600 uppercase tracking-wider text-left">
    { children }
  </th>
)

const InvoiceHeadRow = ({ sortDirection, sortBy, onSort }) => {
  return (
    <tr className="whitespace-nowrap shadow sticky top-0">
      <Th />
      <Th><FormattedMessage {...messages.invoiceId} /></Th>
      <Th><FormattedMessage {...messages.orderId} /></Th>
      <Th><FormattedMessage {...messages.orderName} /></Th>
      <th scope="col" className={`whitespace-nowrap sticky top-0 bg-gray-50 w-1/12 px-1 md:px-2 xl:px-4 py-2 xl:py-3 text-xs font-medium uppercase tracking-wider text-center xl:text-left cursor-pointer hover:bg-gray-200 ${sortBy === 'crdate' ? 'text-gray-800' : ''}`} onClick={onSort('crdate')}>
        <FormattedMessage {...messages.date} />
        <Icon className="ml-1" icon={{ ASC: 'arrow-up', DESC: 'arrow-down' }[sortDirection]} />
      </th>
      <Th><FormattedMessage {...messages.netAmount} /></Th>
      <Th><FormattedMessage {...messages.remainder} /></Th>
      <th scope="col" className="sticky top-0 bg-gray-50 w-20" />
    </tr>
  )
}

export default InvoiceHeadRow
